export const CUSTOMIZER_SCROLL_TOP_OFFSET = 20
